import { PasswordReset } from 'ui/components/supporter/patterns/PasswordReset/PasswordReset';

/**
 * パスワードリセットページ
 */
export const SupportUserPasswordReset: React.FC = () => {
    return <PasswordReset />;
};
